import { createAsyncThunk } from '@reduxjs/toolkit';
import { set } from 'lodash';
import { client } from '../../../api';

export const addMerchantThunk = createAsyncThunk('fundingGroups.addMerchant', async (payload, { rejectWithValue }) => {
  const URL = `/funding/${payload.fundingGroup}/members/${payload.merchant}`;
  try {
    const { data, status, statusText } = await client.post(URL, {});
    return { ...data, status, statusText };
  } catch (err) {
    const { data, status, statusText } = err.response;
    return rejectWithValue({ ...data, status, statusText });
  }
});

export const addMerchantReducers = {
  [addMerchantThunk.fulfilled]: (state, { payload }) => {
    set(
      state,
      'isLoading',
      false,
    );
    set(
      state,
      'addingMerchant',
      payload,
    );
  },
  [addMerchantThunk.pending]: (state) => {
    set(
      state,
      'isLoading',
      true,
    );
  },
  [addMerchantThunk.rejected]: (state, { payload }) => {
    set(
      state,
      'isLoading',
      false,
    );
    set(
      state,
      'addingMerchant',
      payload,
    );
  },
};
